module.exports = __webpack_public_path__ + "static/media/zoom-in.90837b0a.svg";